import { handleJsonResponse, handleFileUploadResponse, getFilterQuery,addSortingQuery } from "./api";
import config from '../config'; 
import { getUser } from '../auth';

export async function getVersion() {
    const user = getUser();
    const token = user?.access_token;
    
    const [authVersion, response] = await Promise.all([
        fetch(`${config.AUTH_URL}/api/version`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }),
        fetch(`${config.API_URL}/about`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
    ]);
    const apiAboutData = await handleJsonResponse(response);
    const authVersionData = await authVersion.json();
    
    return { ...apiAboutData, authVersion: { label: 'Auth Service', version: authVersionData.version } };
}
